import axios from 'axios';

const baseURL = process.env.VUE_APP_API_BASE;

const client = axios.create({ baseURL });

export default client;
